interface LocationWithRadius {
  lat: number
  lng: number
  radius: number
}

export const getBoundsIncludingRadii = (
  locations: LocationWithRadius[],
): google.maps.LatLngBounds => {
  const bounds = new google.maps.LatLngBounds()

  // Helper function to convert meters to degrees latitude
  const metersToLatDegrees = (meters: number) => meters / 111139

  // Helper function to convert meters to degrees longitude
  const metersToLngDegrees = (meters: number, lat: number) =>
    meters / (111139 * Math.cos((lat * Math.PI) / 180))

  locations.forEach(({ lat, lng, radius }) => {
    const latLng = new google.maps.LatLng(lat, lng)
    bounds.extend(latLng)

    // Extend bounds by radius
    const radiusLatDegrees = metersToLatDegrees(radius)
    const radiusLngDegrees = metersToLngDegrees(radius, lat)

    const radiusLatLngs = [
      new google.maps.LatLng(lat + radiusLatDegrees, lng),
      new google.maps.LatLng(lat - radiusLatDegrees, lng),
      new google.maps.LatLng(lat, lng + radiusLngDegrees),
      new google.maps.LatLng(lat, lng - radiusLngDegrees),
    ]

    radiusLatLngs.forEach((latLng) => bounds.extend(latLng))
  })

  // Adding a small buffer to ensure markers are comfortably within the view
  const boundsCenter = bounds.getCenter()
  const boundsRadiusLatDegrees = metersToLatDegrees(10000) // Adjust buffer size if needed
  const boundsRadiusLngDegrees = metersToLngDegrees(10000, boundsCenter.lat()) // Adjust buffer size if needed

  const bufferLatLngs = [
    new google.maps.LatLng(boundsCenter.lat() + boundsRadiusLatDegrees, boundsCenter.lng()),
    new google.maps.LatLng(boundsCenter.lat() - boundsRadiusLatDegrees, boundsCenter.lng()),
    new google.maps.LatLng(boundsCenter.lat(), boundsCenter.lng() + boundsRadiusLngDegrees),
    new google.maps.LatLng(boundsCenter.lat(), boundsCenter.lng() - boundsRadiusLngDegrees),
  ]

  bufferLatLngs.forEach((latLng) => bounds.extend(latLng))

  return bounds
}
